import React, { useState, useEffect } from "react";
import { useLanguage, languages } from "../context/LanguageContext";
import { translations } from "../translations";

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const { language, changeLanguage } = useLanguage();
  
  const t = translations.nav[language] || translations.nav.en;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close language dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.lang-selector')) {
        setIsLangOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <nav id="menu" className={isScrolled ? "scrolled" : ""}>
      <div className="nav-container">
        <a href="/" className="nav-logo">
          <svg viewBox="0 0 40 40" className="logo-icon">
            <rect width="40" height="40" rx="8" fill="#4F46E5"/>
            {/* Code bracket < - centered with 9 */}
            <path d="M10 20 L5 15 L10 10" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.7"/>
            {/* 9 */}
            <text x="20" y="22" fontFamily="-apple-system, BlinkMacSystemFont, sans-serif" fontSize="18" fontWeight="700" fill="#ffffff" textAnchor="middle">9</text>
            {/* Code bracket > - centered with 9 */}
            <path d="M30 10 L35 15 L30 20" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.7"/>
            {/* Code dots */}
            <circle cx="12" cy="32" r="2" fill="#ffffff" opacity="0.5"/>
            <circle cx="20" cy="32" r="2" fill="#ffffff" opacity="0.5"/>
            <circle cx="28" cy="32" r="2" fill="#ffffff" opacity="0.5"/>
          </svg>
          <span>reason</span>
        </a>

        <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <a href="/#services" className="page-scroll" onClick={() => setIsMenuOpen(false)}>{t.services}</a>
          <a href="/#process" className="page-scroll" onClick={() => setIsMenuOpen(false)}>{t.process}</a>
          <a href="/#industries" className="page-scroll" onClick={() => setIsMenuOpen(false)}>{t.industries}</a>
          <a href="/#about" className="page-scroll" onClick={() => setIsMenuOpen(false)}>{t.about}</a>
          <a href="/projects" className="nav-projects" onClick={() => setIsMenuOpen(false)}>{t.projects}</a>
          <a href="/community" className="nav-events" onClick={() => setIsMenuOpen(false)}>{t.events}</a>
          <a href="/#contact" className="page-scroll nav-cta" onClick={() => setIsMenuOpen(false)}>{t.contact}</a>
          
          {/* Language Selector */}
          <div className="lang-selector">
            <button 
              className="lang-btn" 
              onClick={(e) => { e.stopPropagation(); setIsLangOpen(!isLangOpen); }}
              aria-label="Select Language"
            >
              <span className="lang-icon">🌐</span>
              <span className="lang-code">{languages[language]?.code.toUpperCase()}</span>
              <span className="lang-arrow">▾</span>
            </button>
            {isLangOpen && (
              <div className="lang-dropdown">
                {Object.values(languages).map((lang) => (
                  <button
                    key={lang.code}
                    className={`lang-option ${language === lang.code ? 'active' : ''}`}
                    onClick={() => {
                      changeLanguage(lang.code);
                      setIsLangOpen(false);
                      setIsMenuOpen(false);
                    }}
                  >
                    <span className="lang-native">{lang.nativeName}</span>
                    <span className="lang-name">{lang.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <button className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};
